import { render, staticRenderFns } from "./ResourceManagement.vue?vue&type=template&id=38c87e3c&scoped=true&"
import script from "./ResourceManagement.vue?vue&type=script&lang=ts&"
export * from "./ResourceManagement.vue?vue&type=script&lang=ts&"
import style0 from "./ResourceManagement.vue?vue&type=style&index=0&id=38c87e3c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c87e3c",
  null
  
)

export default component.exports